import { render, staticRenderFns } from "./SupplierProductProperties.vue?vue&type=template&id=03e6f028&scoped=true"
import script from "./SupplierProductProperties.vue?vue&type=script&lang=js"
export * from "./SupplierProductProperties.vue?vue&type=script&lang=js"
import style0 from "./SupplierProductProperties.vue?vue&type=style&index=0&id=03e6f028&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e6f028",
  null
  
)

export default component.exports